function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 7">
      <path fill="currentColor" d="M14,0 7,7 0,0Z" />
    </svg>
  );
}

export default Icon;
